import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import axiosHttp from "services/axiosHttp";

export const updateTenderStatus = createAsyncThunk(
    "updateTenderStatus",
    async ({ tenderId, statusId }, { rejectWithValue }) => {
        try {
            const response = await axiosHttp.put(`tms/updatetenderstatus/${tenderId}`, { status: statusId });
            return response.data;
        } catch (err) {
            if (!err.response) throw err;
            return rejectWithValue(err.response.data);
        }
    }
);

const UpdateTenderStatusSlice = createSlice({
    name: "UpdateTenderStatusSlice",
    initialState: {
        isLoading: false,
        data: null,
        error: null,
    },
    reducers: {
        resetUpdateTenderStatus: (state) => {
            state.isLoading = false;
            state.data = null;
            state.error = null;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(updateTenderStatus.pending, (state) => {
                state.isLoading = true;
                state.error = null;
            })
            .addCase(updateTenderStatus.fulfilled, (state, action) => {
                state.isLoading = false;
                state.data = action.payload;
            })
            .addCase(updateTenderStatus.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.payload;
            });
    },
});

export const { resetUpdateTenderStatus } = UpdateTenderStatusSlice.actions;
export default UpdateTenderStatusSlice.reducer;
